import styled from 'styled-components';

import { Color, Gradient } from '../../../shared/constants/Colors';

export const SwitchToggle = styled.i`
  display: block;
  content: '';
  width: 20px;
  height: 20px;
  position: absolute;
  border-radius: 50%;
  top: 50%;
  left: 0;
  transform: ${({ isChecked }) =>
    isChecked ? 'translate(90%, -50%)' : 'translate(0%, -50%)'};
  transition: 0.25s ease;

  &::before {
    display: block;
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24), 0 1px 2px rgba(0, 0, 0, 0.24);

    background: ${Color.WHITE};
    background-image: ${({ isChecked }) =>
      isChecked ? Gradient.FADE_BLUE : 'none'};

    border-radius: 50%;
    z-index: 1;
  }

  &::after {
    display: block;
    content: '';
    width: 200%;
    height: 200%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    transition: 0.25s ease;
  }
`;

export const SwitchControl = styled.button`
  display: block;
  width: 36px;
  height: 14px;
  padding: 0;
  border: 0;
  margin: 0;
  background: ${Color.DUSTY_GREY};
  background-color: ${({ isChecked }) =>
    isChecked ? 'rgba(20,106,255,.6)' : 'none'};
  border-radius: 20px;
  transition: 0.25s ease;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  flex-shrink: 0;
  position: relative;
  opacity: ${({ isDisabled }) => (isDisabled ? '0.38' : '1')};

  &:focus {
    outline: inherit;
  }

  &:hover i::after {
    display: ${({ isDisabled }) => (isDisabled ? 'none' : 'default')};
    background: ${({ isChecked }) =>
      isChecked ? 'rgba(20,106,255,.14)' : 'rgba(35, 48, 66, 0.08)'};
  }

  &:focus {
    i::before {
      background: ${Color.DUSTY_GREY};
      background-image: ${({ isChecked }) =>
        isChecked ? Gradient.FADE_BLUE : 'none'};
    }
    i::after {
      background: ${({ isChecked }) =>
        isChecked ? 'rgba(20,106,255,.28)' : 'rgba(35, 48, 66, 0.16)'};
    }
  }
`;

export const StyledSwitch = styled.div`
  & > div {
    display: none;
  }

  &:hover {
    & > div {
      display: block;
    }
  }
`;
